module.exports = __webpack_public_path__ + "static/media/rabbit.aaa13f4a.jpg";